import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { View } from 'react-native'
import styled from 'styled-components/native'

import Icon from '../../Atoms/Icon'

const Container = styled(View)`
  position: absolute;
  top: 10px;
  right: 10px;
`

class ConnectionStatus extends PureComponent {
  render () {
    let state = 'disconnected'
    if (this.props.connected) {
      state = 'connected'
    } else if (!this.props.connected && this.props.connecting) {
      state = 'connecting'
    }

    return (
      <Container>
        <Icon size='xs' name={state} />
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  connected: state.device.registered && state.device.connected, // && state.device.networkConnected,
  connecting: state.device.registering
})

export default connect(mapStateToProps, {})(ConnectionStatus)
